import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MeterInfo } from '@models/meter-info';
import { MeterOwnership } from '@models/meter-ownership';
import { MeterScanSummary } from '@models/meter-scan-summary.model';
import { CompositeMeterData } from '@models/meter-scans/composite/composite-meter-data';
import { OfdmScan } from '@models/ofdm-scan';
import { Observable } from 'rxjs';
import { map, timeout } from 'rxjs/operators';
import { ObjectHelper } from '@utilities/object-helper';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  })
};

@Injectable()
export class MeterDataService {
  constructor(private http: HttpClient) {
  }

  postCompositeDetail(meterData: CompositeMeterData): Observable<any> {
    const URL = `/meter-data-svc/compMeterData`;
    return this.http.post<CompositeMeterData>(URL, meterData, httpOptions);
  }

  getMeterInfoData(mac: string): Observable<MeterInfo> {
    const URL = `/meter-data-svc/meter/${mac}`;
    return this.http.get<MeterInfo>(URL);
  }

  postOFDM(ofdm: OfdmScan): Observable<Object> {
    const URL = '/meter-data-svc/ofdmData';
    return this.http.post<any>(URL, ofdm);
  }

  getMeterUsers(mac: string): Observable<MeterOwnership[]> {
    const URL = `/meter-data-svc/ownership/meter/${mac}`;
    return this.http.get<MeterOwnership[]>(URL);
  }

  getMeterScansByAccountIdRange(accountId: string | number, start?: string | number, end?: string | number): Observable<MeterScanSummary[]> {
    const URL = `/meter-data-svc/scan-data/account/${accountId}${start ? '?start=' + start : ''}${end ? '&end=' + end : ''}`;
    return this.http.get(URL).pipe(
      map(response => ObjectHelper.copyArray(response, MeterScanSummary))
    );
  }

  getMeterScansByUsernameRange(userId: string | null, start?: string | number, end?: string | number): Observable<MeterScanSummary[]> {
    const URL = `/meter-data-svc/scan-data/user/${userId}${start ? '?start=' + start : ''}${end ? '&end=' + end : ''}`;
    return this.http.get(URL)
      .pipe(
        map(response => ObjectHelper.copyArray(response, MeterScanSummary)),
        timeout(30000));
  }

  getMeterScansByWorkOrderIdRange(workOrderId: string | number, start?: string | number, end?: string | number): Observable<MeterScanSummary[]> {
    const URL = `/meter-data-svc/scan-data/work-order/${workOrderId}${start ? '?start=' + start : ''}${end ? '&end=' + end : ''}`;
    return this.http.get(URL).pipe(
      map(response => ObjectHelper.copyArray(response, MeterScanSummary))
    );
  }

  getMeterScansByGeoLocation(latLongs: { latMin: number, lngMin: number, latMax: number, lngMax: number; }): Observable<MeterScanSummary[]> {
    const URL = `/meter-data-svc/scan-data/by-envelope?min-latitude=${latLongs.latMin}&min-longitude=${latLongs.lngMin}&max-latitude=${latLongs.latMax}&max-longitude=${latLongs.lngMax}&start=0&end=1588957186947`;
    return this.http.get(URL).pipe(
      map(response => ObjectHelper.copyArray(response, MeterScanSummary))
    );;
  }

  updateMeterScanSummary(meterScanSummary: MeterScanSummary): Observable<MeterScanSummary> {
    const URL = 'meter-data-svc/update-meter-scan-summary';
    return this.http.put(URL, meterScanSummary).pipe(
      map(response => ObjectHelper.copyObject(response, MeterScanSummary))
    );;
  }

}
